const labels = {
  ocpMedical: 'ocpMedical',
  fileSizeTooLarge: 'fileSizeTooLarge',
  doHealthDeclaration: 'doHealthDeclaration',
  forgotPassword: 'forgotPassword',
  yourCinNumber: 'yourCinNumber',
  amcConnect: 'amcConnect',
  chooseSpace: 'chooseSpace',
  access: 'access',
  amcSpace: 'amcSpace',
  trackFoldersHistory: 'trackFoldersHistory',
  consultAdhesionsAndContracts: 'consultAdhesionsAndContracts',
  reportMedicalFoldersOnline: 'reportMedicalFoldersOnline',
  reportPac: 'reportPac',
  locateDropOffPoints: 'locateDropOffPoints',
  trackRepayment: 'trackRepayment',
  reportMedicalRecords: 'reportMedicalRecords',
  autoRetailsSavingSpaces: 'autoRetailsSavingSpaces',
  trackClaims: 'trackClaims',
  consultContractAndGuarantee: 'consultContractAndGuarantee',
  consultSavingSituation: 'consultSavingSituation',
  accessSanlamServices: 'accessSanlamServices',
  callAmcCallCenter: 'callAmcCallCenter',
  close: 'modal.close',
  addBeneficiaryHelpDescription: 'addBeneficiaryHelpDescription',
  addBeneficiaryHelpDescription_marriage:
    'addBeneficiaryHelpDescription_marriage',
  addBeneficiaryHelpDescription_birth: 'addBeneficiaryHelpDescription_birth',
  addBeneficiaryHelpDescription_children:
    'addBeneficiaryHelpDescription_children',
  addBeneficiaryHelpDescription_disabled_children:
    'addBeneficiaryHelpDescription_disabled_children',
  makeAppointment: 'makeAppointment',
  refundsRealTimeTracking: 'refundsRealTimeTracking',
  consultYourBenefits: 'consultYourBenefits',
  downloadRefundsCounts: 'downloadRefundsCounts',
  downloadCareSheet: 'downloadCareSheet',
  discoverPersonalizedOffers: 'discoverPersonalizedOffers',
  contactCustomerService: 'contactCustomerService',
  consultAdhesionsContracts: 'consultAdhesionsContracts',
  discoverFeaturesWithNewDesign: 'discoverFeaturesWithNewDesign',
  new: 'new',
  welcomeToYourNewCustomerSpace: 'welcomeToYourNewCustomerSpace',
  addNewContractNotFountAMC: 'addNewContractNotFountAMC',
  invalidEmailFormat: 'invalidEmailFormat',
  downloadFile: 'downloadFile',
  downloadFileShort: 'downloadFileShort',
  downloadAgreementDocument: 'downloadAgreementDocument',
  completeCI: 'completeCI',
  completeCIShort: 'completeCIShort',
};

export default labels;
